import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
  }),
};

@Injectable({
  providedIn: 'root'
})
export class DisciplinaService {
  
  url = environment.baseUrl+'/api/Disciplina';


  constructor(private http: HttpClient) {}

  getDisciplinas(page: number, numReg: number,searchString:string): Observable<any> {
    const body = { page, numReg,searchString };
    return this.http.post<any>(this.url + '/getDisciplinas', body, httpOption);
  }

  getDisciplinasDropdown(): Observable<any> {
    // const body = { page, numReg, searchString };
     return this.http.post<any>(this.url + '/GetDisciplinasDropdown', {}, httpOption);
   }

  addDisciplina(obj:any): Observable<boolean> {
   // const body = { page, numReg, searchString };
    return this.http.post<boolean>(this.url + '/AddDisciplina', obj, httpOption);
  }

  getDisciplina(id:string): Observable<any> {
    // const body = { page, numReg, searchString };
     return this.http.post<any>(this.url + '/GetDisciplina', {id}, httpOption);
   }

   editDisciplina(obj:any): Observable<boolean> {
    // const body = { page, numReg, searchString };
     return this.http.post<boolean>(this.url + '/EditDisciplina', obj, httpOption);
   }

   deleteDisciplina(id:string): Observable<boolean> {
    // const body = { page, numReg, searchString };
     return this.http.post<boolean>(this.url + '/DeleteDisciplina', {id}, httpOption);
   }

}